module.exports = __webpack_public_path__ + "media/images/sp/specials/common/present_wayo2-779110d729c34d136893d2f28bb5d12e.png";